import { MultipleRecordsFormService } from './shared/multiple-records.form.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  OnDestroy
} from '@angular/core';
import { BaseControl, SubForma } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-multiple-records',
  templateUrl: './multiple-records.component.html',
  styleUrls: ['./multiple-records.component.scss'],
  providers: [
    MultipleRecordsFormService
  ]
})
export class MultipleRecordsComponent implements OnInit, OnDestroy {

  // forma
  @Input() form: SubForma;
  // Controles del formulario de fuente de datos para las tablas
  controls: BaseControl<any>[] = [];
  // Array que contiene los datos para el selector
  data: any = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control basico ng-select para el formulario
  @ViewChild('ngSelectFormulario') ngSelectFormulario: TemplateRef<any>;

  constructor(
    private mrfs: MultipleRecordsFormService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.controls = this.mrfs.getFormMultipleRecords(this.form, this.ngSelectFormulario);
    this.dataSelector();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Seleccionar los campos que son de tipo selector
   *
   * @memberof MultipleRecordsComponent
   */
  dataSelector() {
    if (this.form && this.form.campos) {
      for (let i = 0; i < this.form.campos.length; i++) {
        if (this.form.campos[i].tipo_campo.nombre === 'ngSelect') {
          const obj = {
            'id': this.form.campos[i].id,
            'tipo_campo': this.form.campos[i].tipo_campo.nombre,
            'alias': this.form.campos[i].alias
          };
          this.data.push(obj);
        }
      }
    }
  }

  /**
   * Enviar datos de la forma
   *
   * @param {*} data
   * @memberof MultipleRecordsComponent
   */
  sended(data: any) {
    if (data) {
      if (data.cboCampoMultiple) {
        this.form.estilo['campo_multiple'] = data.cboCampoMultiple;
        if (data.chkRegistroTarea) {
          this.form.estilo['registro_tarea'] = true;
        } else {
          this.form.estilo['registro_tarea'] = false;
        }
      } else {
        delete this.form.estilo['registro_tarea'];
        delete this.form.estilo['campo_multiple'];
      }

      this.toastr.success('Se guardó la información', 'Operación exitosa');
    } else {
      this.toastr.error('La información no se guardó', 'Error');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/multiple-records/multiple-records.component.ts